// extracted by mini-css-extract-plugin
export default {"header":"header_header__GKLH3","profile":"header_profile__VikVR","button":"header_button__WNTcz"};